<!--
* @description
* @fileName appealDetails.vue
* @author luoYi
* @date 2022/02/09 10:06:57
* @LastEditors: 最后更新作者
* @LastEditTime: 最后更新时间
!-->
<template>
  <div class="container appealDetailsBox">
    <div class="boxHeader">
      <div class="icon">
        <img :src="detailInfo.currentProcess | processFilter('icon')" />
      </div>
      <div class="textBox">
        <p class="appealResult">
          {{ detailInfo.currentProcess | processFilter('title') }}
        </p>
        <p class="subTitle">
          {{ detailInfo.currentProcess | processFilter('subTitle') }}
        </p>
      </div>
    </div>
    <div class="boxBody">
      <div class="appealCt">
        <div class="ctTxtItem">
          <div class="label">诉求分类</div>
          <div class="value">{{ detailInfo.appealType || '-' }}</div>
        </div>
        <div class="ctBoxItem">
          <div class="TxtItemBox">
            <div class="label">诉求标题</div>
            <div class="value">{{ detailInfo.appealTitle || '-' }}</div>
          </div>
        </div>
        <div class="ctBoxItem">
          <div class="TxtItemBox">
            <div class="label">诉求内容</div>
            <div class="value">
              {{ detailInfo.appealContent || '-' }}
            </div>
          </div>
          <div class="line"></div>
          <div
            class="imgBox"
            v-if="detailInfo.appealUrl && detailInfo.appealUrl.length > 0"
          >
            <img
              v-for="(item, index) in detailInfo.appealUrl"
              :key="index"
              :src="item"
              @click="imgBig(item)"
            />
          </div>
          <div class="imgBox" v-else>
            <img src="../../../assets/coupons-none.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="boxFooter">
      <div class="ctTxtItem">
        <div class="label">企业名称</div>
        <div class="value">{{ detailInfo.entName || '-' }}</div>
      </div>
      <div class="ctTxtItem">
        <div class="label">所在区域</div>
        <div class="value">{{ detailInfo.county || '-' }}</div>
      </div>
      <div class="ctTxtItem">
        <div class="label">联系人</div>
        <div class="value">{{ detailInfo.contact || '-' }}</div>
      </div>
      <div class="ctTxtItem">
        <div class="label">联系电话</div>
        <div class="value">{{ detailInfo.contactTel || '-' }}</div>
      </div>
      <div class="ctTxtItem">
        <div class="label">发起人</div>
        <div class="value">{{ detailInfo.createName || '-' }}</div>
      </div>
      <div class="ctTxtItem">
        <div class="label">发起时间</div>
        <div class="value">{{ detailInfo.createTime || '-' }}</div>
      </div>
    </div>
    <div
      class="boxResultCt"
      v-if="detailInfo.currentProcess === 2 || detailInfo.currentProcess === 3"
    >
      <div class="resultCtTitle">
        <div>受理结果</div>
      </div>
      <div class="ctBoxItem">
        <div class="TxtItemBox">
          <div class="label">处理意见</div>
          <div class="value">
            {{ detailInfo.handleSuggest || '-' }}
          </div>
        </div>
        <div class="line"></div>
        <div class="resultCtFile">
          <div class="boxTitle">附件</div>
          <div
            class="fileList"
            v-if="detailInfo.handleUrl && detailInfo.handleUrl.length > 0"
          >
            <div v-for="(item, index) in detailInfo.handleUrl" :key="index">
              <img
                class="file-big"
                :src="item.fileUrl"
                alt=""
                v-if="getUrlType(item.fileUrl)"
                @click="imgBig(item.fileUrl)"
              />

              <div class="fileItem" v-else>
                <div class="icon">
                  <img src="../../../assets/myAppeal/fileIcon.png" />
                </div>
                <div class="file">
                  <div @click="fileDownload(item.fileUrl)">
                    {{ item.fileName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fileList" v-else>
            <div class="fileItem">暂无数据</div>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="ctTxtItem">
        <div class="label">回复人</div>
        <div class="value">{{ detailInfo.handleName || '-' }}</div>
      </div>
      <div class="ctTxtItem">
        <div class="label">回复时间</div>
        <div class="value">{{ detailInfo.handleTime || '-' }}</div>
      </div>
    </div>
    <div class="boxResultCt" v-if="detailInfo.currentProcess === 3">
      <div class="resultCtTitle">
        <div>评价结果</div>
      </div>
      <div class="ctBoxItem">
        <div class="TxtItemBox">
          <div class="label">满意度</div>
          <div class="value">
            <span>{{ detailInfo.evaluateLevel | starZHFilter }}</span>
            <van-icon
              v-for="i in detailInfo.evaluateLevel"
              :key="i"
              name="star"
              color="#FFC934"
            />
            <van-icon
              v-for="i in 5 - Number(detailInfo.evaluateLevel)"
              :key="i"
              name="star"
              color="#D8D8D8"
            />
          </div>
        </div>
        <div class="line"></div>
        <div class="TxtItemBox">
          <div class="label">评价内容</div>
          <div class="value">
            {{ detailInfo.evaluateContent || '-' }}
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="ctTxtItem">
        <div class="label">评价人</div>
        <div class="value">{{ detailInfo.evaluateName || '-' }}</div>
      </div>
      <div class="ctTxtItem">
        <div class="label">评价时间</div>
        <div class="value">{{ detailInfo.evaluateTime || '-' }}</div>
      </div>
    </div>
    <div class="pjBtn" v-if="detailInfo.currentProcess === 2">
      <van-button type="primary" block @click="showPopupFunc">
        立即评价
      </van-button>
    </div>
    <div
      class="pjBtn"
      v-if="
        detailInfo.currentProcess === 1 && detailInfo.currentRole === '市管理员'
      "
    >
      <van-button type="primary" block @click="editDetailInfo">
        修 改
      </van-button>
    </div>
    <van-popup v-model="showPopup" closeable @closed="closeClearPopup">
      <div class="pjBoxCt">
        <div class="title">我要评价</div>
        <van-form class="pjForm">
          <div class="pjStar">
            <van-rate
              v-model="defaultStar"
              @change="onChangeStar"
              :size="25"
              color="#FFC934"
              void-icon="star"
              void-color="#D8D8D8"
            />
            <div class="pjTextCss">{{ pjText }}</div>
          </div>
          <div class="pjInput">
            <van-field
              type="textarea"
              v-model="pjInputCt"
              :autosize="autoSizeObj"
              placeholder="请输入评价反馈"
            />
          </div>
          <div class="pjBtnGroup">
            <van-button block type="default" @click="closePopup">
              取消
            </van-button>
            <van-button block type="default" @click="onSubmit">
              确认
            </van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
    <div class="popup-img" v-if="isBig" @click="isBig = false">
      <img :src="imgUrl" alt="" />
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import Clipboard from 'clipboard' // 复制功能
import { appealDetail, entEvaluate } from '@api/myAppeal/index'
import slzIcon from '@assets/myAppeal/slzIcon.png'
import checkedIcon from '@assets/myAppeal/checkIcon.png'
export default {
  name: 'AppealDetails',
  data() {
    return {
      showPopup: false,
      defaultStar: 5,
      pjInputCt: '',
      autoSizeObj: { maxHeight: 200, minHeight: 100 },
      // 诉求详情数据
      detailInfo: {},
      // 评价文案
      pjText: '非常满意',
      // 评价等级文案
      starZH: ['非常不满意', '不满意', '一般', '满意', '非常满意'],
      imgUrl: '',
      isBig: false
    }
  },
  filters: {
    processFilter(level, key) {
      // 诉求进度
      const processZH = [
        {
          icon: slzIcon,
          title: '诉求正在受理中，请耐心等待',
          subTitle: '请继续关注平台，第一时间查看最新进展'
        },
        {
          icon: checkedIcon,
          title: '诉求已完结，请评价',
          subTitle: '是否有效地解决了您的诉求？'
        },
        {
          icon: checkedIcon,
          title: '诉求已评价',
          subTitle: '感谢对平台的支持与理解'
        }
      ]
      if (level) {
        return processZH[Number(level) - 1][key]
      } else {
        return '-'
      }
    },
    starZHFilter(level) {
      let starZH = ['非常不满意', '不满意', '一般', '满意', '非常满意']
      return starZH[level - 1]
    }
  },
  components: {},
  computed: {},
  created() {
    this.getAppealDetail()
  },
  methods: {
    // 点击修改 跳转到修改页面
    editDetailInfo() {
      this.$router.replace({
        name: 'initiateAppeal',
        query: { type: 'edit', appealId: this.$route.query.id }
      })
    },
    imgBig(url) {
      this.isBig = true
      this.imgUrl = url
    },
    // 获取文件类型
    getUrlType(data) {
      console.log(data)

      const getSplitData = data.split('.')
      const fileType = getSplitData[getSplitData.length - 1]
      return ['png', 'jpg', 'PNG', 'jpg', 'jpeg', 'JPEG'].includes(fileType)
    },
    // 获取诉求详情
    getAppealDetail() {
      appealDetail({ id: this.$route.query.id }).then((res) => {
        const { code, data, mesg } = res.data
        if (code === '000000') {
          if (data) {
            this.detailInfo = data || {}
            let urls = this.detailInfo.appealUrl
            let files = this.detailInfo.handleUrl
            if (urls) {
              this.detailInfo.appealUrl = urls.split(',')
            } else {
              this.detailInfo.appealUrl = []
            }
            if (files) {
              let fileUrls = files.split(';')
              let fileArr = []
              fileUrls.map((item) => {
                let arr = item.split(',')
                let obj = {}
                obj.fileName = arr[1]
                obj.fileUrl = arr[0]
                fileArr.push(obj)
              })
              this.detailInfo.handleUrl = fileArr
            } else {
              this.detailInfo.handleUrl = []
            }
          } else {
            Toast.fail({
              message: '诉求不存在',
              onClose: () => {
                this.$router.replace({ name: 'appealRecord' })
              }
            })
          }
        } else {
          Toast(mesg)
        }
      })
    },
    // 文件下载
    fileDownload(url) {
      // 判断安卓还是IOS
      let ua = navigator.userAgent
      // let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
      let isiOS = /(iPhone|iPad|iPod|iOS)/i.test(ua)
      if (isiOS) {
        this.$copyText(url).then((res) => {
          Toast('复制链接成功，请前往浏览器打开链接下载文件！')
        })
      } else {
        window.open(url)
      }
    },
    // 评分星级触发事件
    onChangeStar(level) {
      this.pjText = this.starZH[level - 1]
    },
    // 打卡弹出框
    showPopupFunc() {
      this.showPopup = true
      this.pjText = '非常满意'
    },
    // 评价表单提交
    onSubmit() {
      let params = {
        id: this.$route.query.id,
        evaluateLevel: this.defaultStar,
        evaluateContent: this.pjInputCt
      }
      entEvaluate(params).then((res) => {
        const { code, data, mesg } = res.data
        if (code === '000000') {
          Toast('评价成功')
          // location.reload()
          this.getAppealDetail()
        } else {
          Toast(mesg)
        }
      })
      this.closePopup()
    },
    // 关闭弹出框
    closePopup() {
      this.showPopup = false
    },
    // 清除数据
    closeClearPopup() {
      this.defaultStar = 5
      this.pjInputCt = ''
    }
  }
}
</script>
<style lang="scss" scoped>
.appealDetailsBox {
  background: #f8f9fc;
  .popup-img {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    display: flex;
    align-items: center;
    text-align: center;
    img {
      width: 100%;
      height: auto;
    }
  }
  .line {
    width: 100%;
    height: 1px;
    border-bottom: 1px solid rgba(246, 246, 246, 1);
    margin: 15px 0px;
  }
  .boxHeader {
    height: 50px;
    background: url('../../../assets/myAppeal/sqBmg.png') no-repeat;
    background-size: cover;
    display: flex;
    align-items: flex-start;
    color: #ffffff;
    padding: 25px 15px;
    .icon img {
      width: 25px;
      margin-right: 10px;
    }
    .textBox {
      .appealResult {
        font-size: 20px;
        margin: 0px;
        line-height: 28px;
        margin-bottom: 2px;
      }
      .subTitle {
        color: rgba(255, 255, 255, 0.8);
        font-size: 14px;
        margin: 0px;
        line-height: 20px;
      }
    }
  }
  .boxBody,
  .boxFooter,
  .boxResultCt {
    background: #ffffff;
    color: rgba(51, 51, 51, 1);
    font-size: 16px;
    .ctTxtItem {
      display: flex;
      justify-content: space-between;
      padding: 12px 15px;
      line-height: 22px;
      border-bottom: 1px solid rgba(246, 246, 246, 1);
      .label {
        text-align: left;
        width: 75px;
      }
      .value {
        width: calc(100% - 110px);
        text-align: right;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .ctBoxItem {
      padding: 12px 15px;
      .TxtItemBox {
        display: flex;
        justify-content: space-between;
        .label {
          text-align: left;
          width: 75px;
        }
        .value {
          width: calc(100% - 110px);
          text-align: right;
          span {
            margin-right: 5px;
          }
        }
      }
      .imgBox {
        img {
          width: 90px;
          height: 90px;
          margin-right: 15px;
        }
      }
      .resultCtFile {
        .boxTitle {
          font-size: 16px;
          margin-bottom: 10px;
        }
        .fileList {
          .file-big {
            width: 90px;
            height: 90px;
          }

          .fileItem {
            border-radius: 2px;
            background-color: rgba(245, 245, 245, 1);
            margin-bottom: 5px;
            padding: 13px 9px;
            display: flex;
            align-items: flex-start;
            font-size: 14px;

            .icon {
              margin-right: 10px;
              img {
                width: 24px;
                height: 21px;
              }
            }
            .file {
              width: calc(100% - 70px);
              > div {
                line-height: 21px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }
  .boxFooter {
    margin-top: 10px;
  }
  .boxResultCt {
    margin-top: 10px;
    margin-bottom: 30px;
    .resultCtTitle {
      font-size: 18px;
      padding: 15px 12px;
      > div {
        position: relative;
        padding-left: 15px;
        line-height: 25px;
        &::before {
          content: '';
          position: absolute;
          top: 0px;
          left: 0px;
          border: 3px solid rgba(0, 99, 255, 1);
          height: 17px;
          width: 0px;
        }
      }
    }
  }
  .pjBtn {
    margin-top: 10px;
    background: #ffffff;
    padding: 15px;
    .van-button--primary {
      background: #0063ff;
      font-size: 16px;
    }
  }
  .van-popup {
    width: 310px;
  }
  .pjBoxCt {
    margin: 40px 0px 0px;
    color: rgba(51, 51, 51, 1);
    .title {
      text-align: center;
      font-size: 16px;
    }
    .pjForm {
      .pjStar {
        margin: 20px 0px;
        padding: 0px 30px;
        .van-rate {
          margin: 0px 65px;
        }
      }
      .pjTextCss {
        text-align: center;
        font-size: 15px;
        margin: 10px 0px;
      }
      .pjInput {
        padding: 0px 30px;
        margin-bottom: 20px;
        .van-cell {
          border: 1px solid rgba(238, 238, 238, 1);
        }
      }
      .pjBtnGroup {
        display: flex;
        justify-content: space-between;
        font-size: 18px;
        .van-button--default:nth-child(2) {
          border-left: 0px;
          color: #0070ff;
        }
      }
    }
  }
}
</style>
